import { useEffect } from 'react';

/**
 * Injects a JSON-LD structured data <script> into <head> for SEO rich results.
 * Removes it on unmount.
 */
const JsonLd = ({ data, id = 'jsonld' }) => {
  useEffect(() => {
    if (!data) return undefined;
    const scriptId = `jsonld-${id}`;
    let script = document.getElementById(scriptId);
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = scriptId;
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(data);

    return () => {
      const el = document.getElementById(scriptId);
      if (el) el.remove();
    };
  }, [data, id]);

  return null;
};

export default JsonLd;
